import React from "react";
import { useEffect } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

// SCSS
import "./Cursor.scss";

const Cursor = ({ hoveredElement }) => {
  // Cursor Position
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);

  // Cursor Animation
  const springConfig = hoveredElement
    ? {
        damping: 20,
        stiffness: 200,
      }
    : { damping: 40, stiffness: 1000 };

  const x = useSpring(mouseX, springConfig);
  const y = useSpring(mouseY, springConfig);

  // Update cursor position
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (hoveredElement) {
        const { left, top, width, height } = hoveredElement;
        mouseX.set(left + width / 2);
        mouseY.set(top + height / 2);
      } else {
        mouseX.set(e.clientX);
        mouseY.set(e.clientY);
      }
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, [hoveredElement]);

  return (
    <motion.div
      layout
      animate={{
        width: hoveredElement ? hoveredElement.width : 24,
        height: hoveredElement ? hoveredElement.height : 24,
        borderRadius: hoveredElement ? "8px" : "100px",
        backgroundColor: hoveredElement
          ? "rgba(184, 184, 194, 0.3)"
          : "rgba(83, 83, 88, 0.3)",
      }}
      style={{
        x,
        y,
        position: "fixed",
        top: 0,
        left: 0,
      }}
      transition={{
        layout: {
          type: "spring",
          damping: 25,
          stiffness: 200,
        },
      }}
      transformTemplate={({ x, y }) =>
        `translate(${x}, ${y}) translate(-50%, -50%)`
      }
      className="Cursor"
    />
  );
};

export default Cursor;
